/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
function initB2bDiscounts(sectionId) {
  var sectionSelector = '#b2b-discounts-' + sectionId;

  function toggleTablesVisible() {
    const refs = {
      wrap: document.querySelector(sectionSelector + ' [is-com-toggle-wrap]'),
      inputs: document.querySelectorAll(sectionSelector + ' [is-com-table-toggle] input'),
      tables: document.querySelectorAll(sectionSelector + ' [is-com-table]'),
    };

    refs.inputs.forEach((input, inputIdx) => {
      input.addEventListener('change', (event) => {
        const target = event.currentTarget;
        const { checked, value } = target;
        const label = target.closest('label');

        refs.tables.forEach((table) => {
          table.classList.toggle('visually-hidden');
        });

        refs.wrap.dataset.selected = inputIdx + 1;
      });
    });

    const swiperInstance = new Swiper(sectionSelector + ' .content', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      loop: false,
      watchOverflow: true,
       grabCursor: true,
    speed: 300,
    resistanceRatio: 0.85,
    touchRatio: 1,
    touchAngle: 45,
    threshold: 3,
    followFinger: true,
    touchStartPreventDefault: false,
    touchMoveStopPropagation: false,
    nested: true,
    edgeSwipeDetection: true,
    edgeSwipeThreshold: 20,
    watchSlidesProgress: true,
    freeMode: {
      enabled: true,
      momentum: true,
      momentumRatio: 0.4,
      momentumVelocityRatio: 1,
      momentumBounce: false,
      sticky: false,
      minimumVelocity: 0.02,
    },
    cssMode: false,
    keyboard: { enabled: true, onlyInViewport: true },
    mousewheel: { forceToAxis: true, sensitivity: 0.5, releaseOnEdges: true },
      navigation: {
        nextEl: '.b2b-discounts__button-next-' + sectionId,
        prevEl: '.b2b-discounts__button-prev-' + sectionId,
      },
      on: {
        init: updateButtonsVisibility,
        slideChange: updateButtonsVisibility,
        resize: updateButtonsVisibility,
        update: updateButtonsVisibility,
        breakpoint: updateButtonsVisibility
      }
    });

    function updateButtonsVisibility(swiper) {
      const wrapper = swiper.el.querySelector('.b2b-discounts__buttons-wrapper');
      if (!wrapper) return;

      const bothDisabled = swiper.isLocked || (swiper.isBeginning && swiper.isEnd);
      wrapper.style.display = bothDisabled ? 'none' : '';
    }
  }

  toggleTablesVisible();

  if (window.innerWidth > 799 && typeof ScrollReveal !== 'undefined') {
    ScrollReveal().reveal(sectionSelector + ' .sr-hidden', {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      once: true,
      interval: 40
    });
  }
}

$(function () {
  var instances = window.DeskB2bDiscounts || {};
  $.each(instances, function (id) {
    initB2bDiscounts(id);
  });
});